import AreaContainer from "../AreaContainer";
import { useDispatch } from "react-redux";
import { modalSet, nextModalSet } from "_slices/view";
import logEvent from "lib/ga/miscEvent"
import AgentsList from "./AgentsList";
import dynamic from "next/dynamic";
import { Loading } from "components/Loading";
import styles from './agents.module.css';
import globalStyles from '../result.module.css';
import Link from "next/link";
import { useRef } from 'react';
const Ads = dynamic(() => import("../ads"), {
    loading: () => <Loading />,
    ssr: true
})
import { useRouter } from 'next/navigation'

const LocalAgents = ({ agents, id, isLoggedIn, unfilteredAgents, payingClient, type, showPage, property, dxStats }) => {
    let dispatch = useDispatch();
    const router = useRouter();
    const resultLinkRef = useRef(null);

    // DX Ad Defaults
    let addImage = true;
    let titleContent = 'Agent Details Unavailable'
    let paraPart1Content = 'While we don\'t have contact details for this property, we can provide access to thousands of UK properties from across the web with Data-eXchange search!'
    let paraPart2Content = ''
    let addCTAButton = true;

    dxStats = false;  //NB: turns off dx search Adverts

    if (payingClient) { // NB: We show hidden agents for paying customers so the text needs to make sense in this case
        titleContent = 'Find More with Data-eXchange'
        paraPart1Content = 'Search across thousands of UK retail property from around the web all in one place with Data-eXchange search!'
    } else if (!dxStats) { // No DX properties is rare but it can happen
        if (agents?.length > 0) {
            addImage = false
            paraPart1Content = 'We have, however, identified local agents who may be able to help find property in this  area.'
            paraPart2Content = 'Click below to contact local experts.'
            addCTAButton = false;
        } else if (unfilteredAgents?.length > 0) {
            paraPart1Content = 'We have, however, identified agents who may be able to help using our Data-eXchange search!'
        }
    }
    
    return (
        <AreaContainer area="agents" style={null} extraClass={null}>

            {Boolean(payingClient) && (unfilteredAgents?.length > 0) && (
                <AgentsList contactType={'agent'} agents={unfilteredAgents} contactable={true} sponsored={true} id={id} title={""} type={""} display={""} showAllAgentContacts={false} showRibbon={true} property={property} isLoggedIn={isLoggedIn} contactButtonAll={false} />
            )}

            {/* {
                <div className={styles.dxAdvert} style={addCTAButton ? { cursor: "pointer" } : {}} onClick={() => {addCTAButton ? resultLinkRef.current.click() : ''}}>
                    {addImage ? <img loading="lazy" src={`/images/dx/dxLaptop.jpeg`} alt={'dx'} /> : '' }
                    <div className={styles.dxAdvertContent}>
                        <p className={styles.bold}>{titleContent}</p>
                        <p>{paraPart1Content}</p>
                        {dxStats && unfilteredAgents?.length > 0 ? <p>There are an additional <span className={styles.collectedNumber}>{dxStats}</span> properties available to view in this area.</p> : <p>{paraPart2Content}</p>}
                        {addCTAButton ? 
                            <Link href={`/data-exchange`} passHref prefetch={false} >
                                <button ref={resultLinkRef} className={styles.secondaryButton}>Find out more</button>
                            </Link> 
                        : ''
                        }
                    </div>
                </div>
            } */}

            {Boolean(agents) && agents.length > 0 && (
                <div className={styles.GridContainer} id="agent-contain">
                    <div className={styles.gridRow}>
                        <h3 className={`${globalStyles.subtitleHeading} ${styles.localAgentsHead}`}> <img alt='approved agents' src='/icons/approvedAgents.svg' loading="lazy" height="30" width="30"></img> <span>Local Experts</span></h3>
                    </div>
                    <div className={styles.contentRow}>
                        {agents.map((agent) => {
                            return (
                                <AgentListItem key={agent.id} company={agent} contactType={'local_agent'} />
                            );
                        })}
                    </div>
                    <div className={styles.buttonContainerContact}>
                        <button className={`${styles.smallButton} ${styles.fullWidth}`} onClick={(e) => {
                            logEvent({
                                category: "Local agent Contact",
                                action: "Email modal opened",
                                label: `Property: ${id}`,
                            });
                            if (isLoggedIn) {
                                dispatch(
                                    modalSet({
                                        visible: true,
                                        type: "localAgentsContact",
                                        view: id,
                                        router
                                    })
                                );
                            } else {
                                dispatch(
                                    modalSet({
                                        visible: true,
                                        type: "auth",
                                        view: "register",
                                        router,
                                        propertyPage: true
                                    })
                                );
                                dispatch(
                                    nextModalSet({
                                        visible: true,
                                        type: "localAgentsContact",
                                        view: id.toString(),
                                        router
                                    })
                                );
                            }
                        }}>
                            <div className={globalStyles.largeText} > {agents?.length > 0 ? 'Contact Local Experts' : 'Property contact details not available'} </div>
                        </button>
                    </div>
                </div>
            )}
            {Boolean(agents) && agents.length === 0 && showPage && (
                <Ads style={{ display: "block", height: '250px', width: 'auto' }} includeScript={false} />
            )}
        </AreaContainer>
    )
}

const AgentListItem = ({ company }) => {
    return (
        <div className={styles.agentSlideContainer}>
            <div className={styles.companyPadder} >
                <div className={styles.companyContainer}>
                    <div className={styles.companyLogo}>
                        {company.logo_uri &&
                            <img alt={`${company.name} logo`} src={`${process.env.NEXT_PUBLIC_APP_MEDIA_URL}${company.logo_uri}`} loading="lazy" height="auto" width="auto"></img>}
                    </div>
                    <div className={styles.companyBorder} />
                    <div className={styles.agentDetails}>
                        <p className={globalStyles.largeText}>{company.name}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}



export default LocalAgents;
